import React, { useState, useEffect } from "react";
import {
    Button,
    TextField,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Select,
    MenuItem,
    Typography,
    Box,
    Grid,
    InputAdornment,
    FormLabel,
    Alert,
    Switch,
    useMediaQuery,
    CircularProgress,
    IconButton,
} from "@mui/material";
import Cookies from "js-cookie";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MapContainer from "../pages/MapContainer";
import {
    createPetLostRecord,
    getDogBreeds,
    getCatBreeds,
} from "../services/api";
import { validateDate, convertFromISO } from "../utils/dateValidation";
import DatePickerField from "../components/DatePickerField";
import { validatePetPhoneNumber } from "../utils/validation";
import { wrap } from "lodash";
import { getPets, } from "../services/api";



export default function PetLostReport() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [success, setSuccess] = useState(false);
    const isMobile = useMediaQuery("(max-width:900px)");
    const [searchParams] = useSearchParams();
    const member = searchParams.get("member") || '';
    const Logged = searchParams.get("Logged") || '';
    const Created = searchParams.get("created") || '';
    const [error, setError] = useState(false);
    const [BackColor, setBackColor] = useState("");
    const [UpdateMessage, setUpdateMessage] = useState("");
    const [showCurrentMap, setShowCurrentMap] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    const getUserId = () => {
        const id = Cookies.get("id");
        return id;
    };

    const [formErrors, setFormErrors] = useState({});
    const [dateErrors, setDateErrors] = useState({});
    const [fieldErrors, setFieldErrors] = useState({});
    const [buttonLoading, setButtonLoading] = useState(false);
    const [basicInfo, setBasicInfo] = useState({
        petId : "",
        name: "",
        birthday: "",
        sex: "",
        sterilization: null,
        status: "遺失",
        animal: "",
        breed: "",
        weight: "",
        description: "",
        remarks: "",
        owner: "",
        ownerContact1: "",
        lostDate: convertFromISO(Date.now()),
        lostLocation: "",
        lostDistrict: "",
    });

    const [pets, setPets] = useState([]);
    useEffect(() => {
        if (getUserId()) {
            const loadPets = async () => {
                try {
                    const response = await getPets(getUserId());
                    const petsData = response.data.form || [];
                    setPets(petsData);

                } catch (err) {
                    if (err.response && err.response.status === 404) {
                        console.log("No pets found for this user.");
                    }
                    console.error("Error loading pets:", err);
                } finally {
                }
            };

            loadPets();
        }
    }, []);

    const Label = ({ children, htmlFor, className, ...props }) => (
        <Typography
            component="label"
            htmlFor={htmlFor}
            className={className}
            variant="body2"
            color="textPrimary"
            {...props}
        >
            {children}
        </Typography>
    );

    const [imagePreviews, setImagePreviews] = useState([]); // Array of preview URLs
    const [imageFiles, setImageFiles] = useState([]);       // Array of File objects
    const [removedImageIndices, setRemovedImageIndices] = useState([]); // Track indices of removed images from AWS
    const [existingImagesCount, setExistingImagesCount] = useState(0); // Track original image count from AWS

    // Image compression utility
    const compressImage = async (file) => {
        const fileSizeMB = file.size / (1024 * 1024);
        
        // Reject files larger than 10MB
        if (fileSizeMB > 10) {
            setError(true);
            setBackColor("#d32f2f");
            setUpdateMessage(t('ImageTooLarge'));
            setTimeout(() => {
                setError(false);
            }, 2000);
        }
        
        let quality;
        if (fileSizeMB <= 0.3) {
            quality = 1; 
        } else if (fileSizeMB <= 1) {
            quality = 0.5; 
        } else if (fileSizeMB <= 2) {
            quality = 0.2; 
        } else {
            quality = 0.1; 
        }
        
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    
                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                const compressedFile = new File([blob], file.name, {
                                    type: 'image/jpeg',
                                    lastModified: Date.now(),
                                });
                                console.log(`Compressed ${file.name}: ${fileSizeMB.toFixed(2)}MB → ${(blob.size / (1024 * 1024)).toFixed(2)}MB`);
                                resolve(compressedFile);
                            } else {
                                reject(new Error('Compression failed'));
                            }
                        },
                        'image/jpeg',
                        quality
                    );
                };
                img.onerror = () => reject(new Error('Failed to load image'));
            };
            reader.onerror = () => reject(new Error('Failed to read file'));
        });
    };

    // Image upload handler - supports multiple images with compression
    const handleImageChange = async (e) => {
        const files = Array.from(e.target.files);
        const newFiles = [];
        
        for (const file of files) {
            if (file && file.type.startsWith("image/")) {
                try {
                    // Compress the image
                    const compressedFile = await compressImage(file);
                    newFiles.push(compressedFile);
                    
                    // Create preview
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        setImagePreviews(prev => [...prev, reader.result]);
                    };
                    reader.readAsDataURL(compressedFile);
                } catch (error) {
                    console.error("Error processing image:", error);
                    setError(true);
                    setBackColor("#d32f2f");
                    setUpdateMessage(error.message);
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                    // Skip this file and continue with others
                    continue;
                }
            }
        }

        if (newFiles.length > 0) {
            setImageFiles(prev => [...prev, ...newFiles]);
            setBasicInfo({
                ...basicInfo,
                imageFiles: [...(basicInfo.imageFiles || []), ...newFiles], // Store all compressed files for upload
            });
        }
    };

    // Remove image handler
    const handleRemoveImage = (idx) => {
        // Check if this is an existing image from AWS (within the original count)
        if (idx < existingImagesCount) {
            // Track the index of the removed existing image
            setRemovedImageIndices(prev => [...prev, idx]);
        }

        // Remove from previews
        setImagePreviews(prev => prev.filter((_, i) => i !== idx));

        // Remove from new files if it's beyond existing images count
        const newFileIndex = idx - existingImagesCount;
        if (newFileIndex >= 0) {
            setImageFiles(prev => prev.filter((_, i) => i !== newFileIndex));
            setBasicInfo({
                ...basicInfo,
                imageFiles: imageFiles.filter((_, i) => i !== newFileIndex),
            });
        }

        // Adjust existing images count if we removed an existing image
        if (idx < existingImagesCount) {
            setExistingImagesCount(prev => prev - 1);
        }
    };

    const validateForm = () => {
        const errors = {};
        const newDateErrors = {};

        if (!basicInfo.lostDistrict) errors.lostDistrict = "請填寫發現該動物的區域。";
        if (!basicInfo.lostDate) {
            errors.lostDate = "請輸入遺失日期";
        } else {
            const dateValidation = validateDate(basicInfo.lostDate);
            if (!dateValidation.isValid) {
                newDateErrors.lostDate = dateValidation.error;
            }
        }
        if (imagePreviews.length === 0 && !member) {
            errors.images = "請上傳至少一張圖片";
        }
        if (!basicInfo.lostLocation) errors.lostLocation = "請輸入遺失地點";
        else {
            const dateValidation = validateDate(basicInfo.birthday);
            if (!dateValidation.isValid) {
                newDateErrors.birthday = dateValidation.error;
            }
        }
        if (!basicInfo.animal) errors.animal = "請選擇物種";
        if (!basicInfo.owner) errors.owner = "請輸入聯絡人";
        if (!basicInfo.ownerContact1) errors.ownerContact1 = "請輸入主要聯絡電話";

        setFormErrors(errors);
        setDateErrors(newDateErrors);
        return (
            Object.keys(errors).length === 0 &&
            Object.keys(newDateErrors).length === 0 &&
            !fieldErrors.ownerContact1 &&
            !fieldErrors.ownerContact2
        );
    };

    const handleSubmit = async (e) => {
        console.log("Selected Pet:", basicInfo);
        setButtonLoading(true);
        e.preventDefault();

        if (!validateForm()) {
            setButtonLoading(false); // <-- Add this line
            return;
        }
        // Create pet lost record
        const userId = getUserId() || "68dd1b64788f3ae289798c05";
        const response = await createPetLostRecord(userId, basicInfo);
        if (response.status === 201) {
            setButtonLoading(false);
            setFormErrors({});
            navigate("/pet_lost_confirmation");
        }

    };

    // Breeds data state
    const [dogBreeds, setDogBreeds] = useState([]);
    const [catBreeds, setCatBreeds] = useState([]);
    const [breedsLoading, setBreedsLoading] = useState(true);
    const [dogBreedsMapping, setDogBreedsMapping] = useState({});
    const [catBreedsMapping, setCatBreedsMapping] = useState({});

    // Load dog breeds data
    const loadDogBreeds = async (lang) => {
        try {
            const response = await getDogBreeds(lang);
            const breedsData = response.data.result || [];
            setDogBreeds(breedsData);

            // Load the opposite language for mapping
            const oppositeLang = lang === 'en' ? 'zh' : 'en';
            const oppositeResponse = await getDogBreeds(oppositeLang);
            const oppositeBreedsData = oppositeResponse.data.result || [];

            // Create a mapping between the two languages
            const mapping = {};
            breedsData.forEach((breed, index) => {
                if (oppositeBreedsData[index]) {
                    mapping[breed] = oppositeBreedsData[index];
                    mapping[oppositeBreedsData[index]] = breed;
                }
            });
            setDogBreedsMapping(mapping);
        } catch (err) {
            console.error("Error loading dog breeds:", err);
        }
    };

    // Load cat breeds data
    const loadCatBreeds = async (lang) => {
        try {
            const response = await getCatBreeds(lang);
            const breedsData = response.data.result || [];
            setCatBreeds(breedsData);

            // Load the opposite language for mapping
            const oppositeLang = lang === 'en' ? 'zh' : 'en';
            const oppositeResponse = await getCatBreeds(oppositeLang);
            const oppositeBreedsData = oppositeResponse.data.result || [];

            // Create a mapping between the two languages
            const mapping = {};
            breedsData.forEach((breed, index) => {
                if (oppositeBreedsData[index]) {
                    mapping[breed] = oppositeBreedsData[index];
                    mapping[oppositeBreedsData[index]] = breed;
                }
            });
            setCatBreedsMapping(mapping);
        } catch (err) {
            console.error("Error loading cat breeds:", err);
        }
    };

    // Load all breeds data
    const loadAllBreeds = async (lang) => {
        try {
            setBreedsLoading(true);
            await Promise.all([loadDogBreeds(lang), loadCatBreeds(lang)]);
        } catch (err) {
            console.error("Error loading breeds:", err);
        } finally {
            setBreedsLoading(false);
        }
    };

    // Translate breed when language changes or when breeds are loaded
    useEffect(() => {
        if (basicInfo.breed && basicInfo.animal && !breedsLoading) {
            const currentBreeds = basicInfo.animal === "狗" ? dogBreeds : basicInfo.animal === "貓" ? catBreeds : [];
            const currentMapping = basicInfo.animal === "狗" ? dogBreedsMapping : catBreedsMapping;

            // If the current breed doesn't exist in the current language's options
            if (currentBreeds.length > 0 && !currentBreeds.includes(basicInfo.breed)) {
                // Try to translate it using the mapping
                if (currentMapping[basicInfo.breed]) {
                    setBasicInfo(prev => ({
                        ...prev,
                        breed: currentMapping[basicInfo.breed]
                    }));
                } else {
                    // If no mapping found, reset to empty to avoid MUI error
                    console.warn(`Breed "${basicInfo.breed}" not found in current language. Resetting.`);
                }
            }
        }
    }, [i18n.language, dogBreeds, catBreeds, dogBreedsMapping, catBreedsMapping, breedsLoading]);

    // Load breeds when language changes
    useEffect(() => {
        const lang = i18n.language;
        loadAllBreeds(lang);
    }, [i18n.language]);

    // Handle field changes with validation
    const handleFieldChange = (field, value) => {
        setBasicInfo({ ...basicInfo, [field]: value });

        // Real-time validation for specific fields
        if (field === "ownerContact1") {
            const phoneError = validatePetPhoneNumber(value, true);
            setFieldErrors((prev) => ({
                ...prev,
                ownerContact1: phoneError,
            }));
        } else {
            // Clear error when field is filled
            setFieldErrors((prev) => ({
                ...prev,
                [field]: "",
            }));
        }
    };

    const popupOverlayStyle = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent overlay
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000, // Ensure popup is above other content
        overflow: "auto",
    };

    const popupContentStyle2 = {
        backgroundColor: "#FFFFFF",
        padding: "30px",
        borderRadius: "30px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        width: isMobile ? "93%" : "1000px",
        display: "flex",
        flexDirection: "column",
        gap: 20,
    };

    const closeButtonStyle = {
        position: "absolute", top: 0, right: isMobile ? "-10px" : 0,
        cursor: "pointer",
    };

    const handleClosePopup = () => {
        setShowCurrentMap(false);
    };


    return (
        <Box
            sx={{ background: "#FCF8F3", minHeight: "100vh", pt: 15, position: "relative" }}
        >
            <Navbar />
            <Box sx={{ color: "black", minWidth: 0, position: "absolute", left: isMobile ? 10 : 80, display: 'flex', }}>
                <Button
                    sx={{ color: "black", minWidth: 0, }}
                    onClick={() => Created ? navigate("/pet-management") : Logged ? navigate("/pet_lost_search") : navigate("/pet_lost_member")}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 24" fill="none">
                        <path d="M12 22L2 12L12 2" stroke="#050505" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </Button>
                <Typography sx={{ ml: 1, fontSize: isMobile ? 26 : 34, fontWeight: 700 }}>{t('Publish')}</Typography>
            </Box>
            <Box sx={{ pt: 10, px: isMobile ? 2 : 10, }}>

                {/* Lost remarks Section */}
                <Box sx={{ mt: 6, mb: 2, px: 3, }}>
                    <Typography
                        variant="h6"
                        fontWeight={700}
                        sx={{ mb: 2, color: "#050505" }}
                    >
                        {t('LostDetails')}
                    </Typography>
                    <Grid container justifyContent="space-between" spacing={3}>
                        <Grid item xs={12} md={4} sx={{ width: 400, }}>
                            <Label htmlFor="owner" sx={{ display: "block", mb: 1 }}>
                                {t('LostDate')}
                                <span style={{ color: "red", marginLeft: 4 }}>*</span>
                            </Label>
                            <DatePickerField
                                id="lostDate"
                                name="lostDate"
                                placeholder="DD/MM/YYYY"
                                value={basicInfo.lostDate || ""}
                                onChange={(value) => {
                                    setBasicInfo({ ...basicInfo, lostDate: value });
                                    if (formErrors.lostDate) {
                                        setFormErrors({ ...formErrors, lostDate: "" });
                                    }
                                }}
                                onError={(error) =>
                                    setDateErrors({ ...dateErrors, lostDate: error })
                                }
                                required
                                sx={{
                                    width: isMobile ? 310 : 400,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "white",
                                    },
                                }}
                            />
                            {formErrors.lostDate && (
                                <Typography color="error" variant="caption">
                                    {formErrors.lostDate}
                                </Typography>
                            )}
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                <Label htmlFor="lostDistrict">
                                    {t('Region')}
                                    <span style={{ color: "red", marginLeft: 4 }}>*</span>
                                </Label>

                            </Box>
                            <FormControl fullWidth error={!!formErrors.foundDistrict}>
                                <Select
                                    id="lostDistrict"
                                    name="lostDistrict"
                                    value={basicInfo.lostDistrict}
                                    onChange={(e) => {
                                        setBasicInfo({ ...basicInfo, lostDistrict: e.target.value });
                                        if (formErrors.lostDistrict) {
                                            setFormErrors({ ...formErrors, lostDistrict: "" });
                                        }
                                    }}
                                    displayEmpty
                                    sx={{
                                        width: isMobile ? 310 : 400,
                                        backgroundColor: "white",
                                        "& .MuiOutlinedInput-root": {
                                            backgroundColor: "white",
                                        },
                                    }}
                                    MenuProps={{
                                        disableScrollLock: true
                                    }}
                                >
                                    <MenuItem value="" disabled>
                                        {t('PleaseSelectArea')}
                                    </MenuItem>
                                    <MenuItem value="中西區">{t('Central and Western District')}</MenuItem>
                                    <MenuItem value="灣仔區">{t('Wan Chai District')}</MenuItem>
                                    <MenuItem value="東區">{t('Eastern District')}</MenuItem>
                                    <MenuItem value="南區">{t('Southern District')}</MenuItem>
                                    <MenuItem value="油尖旺區">{t('Yau Tsim Mong District')}</MenuItem>
                                    <MenuItem value="深水埗區">{t('Sham Shui Po District')}</MenuItem>
                                    <MenuItem value="九龍城區">{t('Kowloon City District')}</MenuItem>
                                    <MenuItem value="黃大仙區">{t('Wong Tai Sin District')}</MenuItem>
                                    <MenuItem value="觀塘區">{t('Kwun Tong District')}</MenuItem>
                                    <MenuItem value="荃灣區">{t('Tsuen Wan District')}</MenuItem>
                                    <MenuItem value="屯門區">{t('Tuen Mun District')}</MenuItem>
                                    <MenuItem value="元朗區">{t('Yuen Long District')}</MenuItem>
                                    <MenuItem value="北區">{t('North District')}</MenuItem>
                                    <MenuItem value="大埔區">{t('Tai Po District')}</MenuItem>
                                    <MenuItem value="沙田區">{t('Sha Tin District')}</MenuItem>
                                    <MenuItem value="西貢區">{t('Sai Kung District')}</MenuItem>
                                    <MenuItem value="葵青區">{t('Kwai Tsing District')}</MenuItem>
                                    <MenuItem value="離島區">{t('Islands District')}</MenuItem>
                                </Select>
                                {formErrors.lostDistrict && (
                                    <Typography color="error" variant="caption" sx={{ mt: 1 }}>
                                        {formErrors.lostDistrict}
                                    </Typography>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                <Label htmlFor="LostLocation">
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', }}>
                                        <Box >{t('LostLocation')}</Box>
                                        <span style={{ color: "red", marginLeft: 4 }}>*</span>
                                        <Box onClick={() => setShowCurrentMap(true)} sx={{ mx: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', height: 20, cursor: 'pointer', ":hover": { opacity: 0.4 } }}>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.9108 -0.0271076C11.8717 -0.0200583 11.8332 -0.0105 11.7954 0.00150776C11.587 0.048217 11.4012 0.165745 11.2698 0.334064C11.1383 0.502383 11.0693 0.711077 11.0745 0.924585V1.90582C6.2163 2.34612 2.34214 6.22028 1.90091 11.0784H0.920607C0.891699 11.0771 0.862744 11.0771 0.833837 11.0784C0.589022 11.0899 0.358805 11.1982 0.19383 11.3795C0.0288561 11.5607 -0.0573613 11.8001 -0.045855 12.0449C-0.0343487 12.2897 0.0739388 12.5199 0.255186 12.6849C0.436432 12.8499 0.675791 12.9361 0.920607 12.9246H1.90184C2.34214 17.7827 6.2163 21.6569 11.0745 22.0981V23.0784C11.0745 23.3232 11.1717 23.558 11.3448 23.7311C11.5179 23.9043 11.7527 24.0015 11.9975 24.0015C12.2423 24.0015 12.4771 23.9043 12.6502 23.7311C12.8234 23.558 12.9206 23.3232 12.9206 23.0784V22.0972C17.7788 21.6569 21.6529 17.7827 22.0941 12.9246H23.0745C23.3193 12.9246 23.5541 12.8273 23.7272 12.6542C23.9003 12.4811 23.9975 12.2463 23.9975 12.0015C23.9975 11.7567 23.9003 11.5219 23.7272 11.3488C23.5541 11.1757 23.3193 11.0784 23.0745 11.0784H22.0932C21.6529 6.22028 17.7797 2.34612 12.9206 1.90489V0.924585C12.9253 0.793321 12.9019 0.662574 12.852 0.541079C12.802 0.419585 12.7268 0.31014 12.6312 0.220057C12.5356 0.129974 12.4219 0.0613283 12.2977 0.018705C12.1734 -0.0239182 12.0415 -0.0395369 11.9108 -0.0271076ZM11.0745 4.67412V5.53997C11.0745 5.78478 11.1717 6.01957 11.3448 6.19268C11.5179 6.36579 11.7527 6.46305 11.9975 6.46305C12.2423 6.46305 12.4771 6.36579 12.6502 6.19268C12.8234 6.01957 12.9206 5.78478 12.9206 5.53997V4.67412C14.5485 4.87683 16.0623 5.61675 17.2223 6.77675C18.3823 7.93674 19.1222 9.45052 19.3249 11.0784H18.4591C18.4302 11.0771 18.4012 11.0771 18.3723 11.0784C18.1275 11.0899 17.8973 11.1982 17.7323 11.3795C17.5673 11.5607 17.4811 11.8001 17.4926 12.0449C17.5041 12.2897 17.6124 12.5199 17.7936 12.6849C17.9749 12.8499 18.2143 12.9361 18.4591 12.9246H19.3249C19.1222 14.5525 18.3823 16.0663 17.2223 17.2263C16.0623 18.3863 14.5485 19.1262 12.9206 19.3289V18.463C12.924 18.3228 12.8954 18.1836 12.837 18.056C12.7785 17.9285 12.6917 17.8159 12.5833 17.7269C12.4748 17.6379 12.3474 17.5748 12.2109 17.5424C12.0744 17.51 11.9323 17.5092 11.7954 17.54C11.587 17.5867 11.4012 17.7042 11.2698 17.8725C11.1383 18.0408 11.0693 18.2495 11.0745 18.463V19.3289C9.44655 19.1262 7.93276 18.3863 6.77277 17.2263C5.61278 16.0663 4.87285 14.5525 4.67014 12.9246H5.53599C5.78081 12.9246 6.01559 12.8273 6.1887 12.6542C6.36182 12.4811 6.45907 12.2463 6.45907 12.0015C6.45907 11.7567 6.36182 11.5219 6.1887 11.3488C6.01559 11.1757 5.78081 11.0784 5.53599 11.0784H4.67014C4.87285 9.45052 5.61278 7.93674 6.77277 6.77675C7.93276 5.61675 9.44655 4.87683 11.0745 4.67412Z" fill="black" />
                                            </svg>
                                        </Box>
                                    </Box>
                                </Label>

                            </Box>
                            <TextField
                                id="lostLocation"
                                name="lostLocation"
                                placeholder={t('LostLocationPlaceholder')}
                                value={basicInfo.lostLocation}
                                onChange={(e) => {
                                    handleFieldChange("lostLocation", e.target.value);
                                    if (formErrors.lostLocation) {
                                        setFormErrors({ ...formErrors, lostLocation: "" });
                                    }
                                }
                                }
                                fullWidth
                                variant="outlined"

                                sx={{
                                    width: isMobile ? 310 : 400,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "white",
                                    },
                                }}
                                error={!!dateErrors.lostLocation || !!formErrors.lostLocation}
                                helperText={dateErrors.lostLocation || formErrors.lostLocation}
                            />
                        </Grid>

                    </Grid>
                </Box>

                <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ mt: 3, mb: 1, fontSize: isMobile ? 16 : 20, px: 3, pb: 2 }}
                >
                    {t('LostPet')}
                </Typography>
                {member ? (
                    <Grid container justifyContent="space-between" sx={{ px: 3 }} >
                        <Grid item xs={12} md={4} sx={{ width: 400, mb: isMobile ? 2 : 0 }}>
                            <Label htmlFor="owner" sx={{ display: "block", mb: 1 }}>
                                {t('LostPet')}
                            </Label>
                            <FormControl fullWidth>
                                <Select
                                    id="name"
                                    name="name"
                                    value={basicInfo.name}
                                    onChange={(e) => {
                                        const selectedPet = pets.find((pet) => pet.name === e.target.value);
                                        
                                        if (selectedPet) { //handlesubmit 
                                            setBasicInfo({
                                                ...basicInfo,
                                                ...selectedPet,
                                                status: "遺失",
                                                name: selectedPet.name, // ensure name is set
                                                petId : selectedPet._id,
                                            });
                                            setFormErrors({ ...formErrors, owner: "", ownerContact1: "" });
                                        } else {
                                            setBasicInfo({ ...basicInfo, name: e.target.value });
                                        }
                                    }}
                                    displayEmpty
                                    sx={{
                                        backgroundColor: "white",
                                        "& .MuiOutlinedInput-root": {
                                            backgroundColor: "white",
                                        },
                                    }}
                                    MenuProps={{
                                        disableScrollLock: true,
                                    }}
                                >
                                    <MenuItem value="" disabled>
                                        {t('PleaseSelectLostPet')}
                                    </MenuItem>
                                    {pets.map((pet) => (
                                        <MenuItem key={pet._id || pet.name} value={pet.name}>
                                            {pet.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ mb: isMobile ? 2 : 0 }}>
                            <Box sx={{ display: "flex", alignItems: "center", }}>
                                <Label htmlFor="Description" sx={{ display: "block", mb: 1 }}>
                                    {t('Description')}
                                </Label>

                            </Box>
                            <TextField
                                id="Description"
                                name="Description"
                                placeholder={t("DesriptionPlaceholder")}
                                value={basicInfo.description || ""}
                                onChange={(e) =>
                                    setBasicInfo({ ...basicInfo, description: e.target.value })
                                }
                                fullWidth
                                variant="outlined"

                                sx={{
                                    width: isMobile ? 310 : 400,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "white",
                                    },
                                    "& .MuiInputBase-input": {
                                        resize: "vertical", // allow vertical resizing
                                        overflow: "auto"
                                    }
                                }}

                            />
                        </Grid>

                        <Grid item xs={12} md={4} sx={{ mb: isMobile ? 2 : 0 }}>
                            <Box sx={{ display: "flex", alignItems: "center", }}>
                                <Label htmlFor="remarks" sx={{ display: "block", mb: 1 }}>
                                    {t('Remarks')}
                                </Label>

                            </Box>
                            <TextField
                                id="remarks"
                                name="remarks"
                                placeholder={t('RemarksPlaceholder')}
                                value={basicInfo.remarks || ""}
                                onChange={(e) =>
                                    setBasicInfo({ ...basicInfo, remarks: e.target.value })
                                }
                                fullWidth
                                variant="outlined"

                                sx={{
                                    width: isMobile ? 310 : 400,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "white",
                                    },
                                    "& .MuiInputBase-input": {
                                        resize: "vertical", // allow vertical resizing
                                        overflow: "auto"
                                    }
                                }}

                                multiline

                            />
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container justifyContent="space-between" sx={{ px: 3 }}>
                        {/* First Column - Basic remarks and Photo */}
                        <Grid item xs={12} md={4}>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 3, minWidth: isMobile ? 310 : 400 }}>
                                {/* Name */}
                                <Box>
                                    <Label htmlFor="name" sx={{ display: "block", mb: 1, }}>
                                        {t('Name')}

                                    </Label>
                                    <TextField
                                        id="name"
                                        name="name"
                                        placeholder={t('Name')}
                                        value={basicInfo.name || ""}
                                        onChange={(e) => {
                                            setBasicInfo({ ...basicInfo, name: e.target.value });
                                        }}
                                        fullWidth
                                        variant="outlined"
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                backgroundColor: "white",
                                            },
                                        }}
                                    />
                                </Box>
                                {/* Breed Image */}
                                <Box sx={{ flexGrow: 1 }}>
                                    <Label sx={{ display: "block", mb: 1 }}>
                                        {t('Photos5')}
                                        <span style={{ color: "red", marginLeft: 4 }}>*</span>
                                    </Label>
                                    <Box
                                        sx={{
                                            border: 1,
                                            borderColor: "grey.300",
                                            borderRadius: 1,
                                            p: 4,
                                            display: "flex",
                                            flexDirection: "row",
                                            flexWrap: "wrap",
                                            alignItems: imagePreviews.length > 0 ? "flex-start" : "center",
                                            justifyContent: imagePreviews.length > 0 ? "flex-start" : "center",
                                            gap: 2,
                                            minHeight: 300,
                                            width: isMobile ? 310 : 400,
                                            backgroundColor: "white",
                                            position: "relative",
                                        }}
                                    >
                                        {imagePreviews.length > 0 ? (
                                            imagePreviews.map((preview, idx) => (
                                                <Box key={idx} sx={{ position: "relative", }}>
                                                    <img
                                                        src={preview}
                                                        alt={`預覽圖片${idx + 1}`}
                                                        style={{
                                                            maxWidth: 100,
                                                            maxHeight: 100,
                                                            marginBottom: 8,
                                                            borderRadius: 8,
                                                            objectFit: "cover",
                                                        }}
                                                    />
                                                    <IconButton
                                                        size="small"
                                                        sx={{
                                                            position: "absolute",
                                                            top: -10,
                                                            right: -10,
                                                            background: "rgba(66, 66, 66, 0.7)",
                                                            zIndex: 2,
                                                        }}
                                                        onClick={() => handleRemoveImage(idx)}
                                                    >
                                                        <CloseIcon fontSize="small" fill="white" />
                                                    </IconButton>
                                                </Box>

                                            ))
                                        ) : (
                                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="25" height="25" rx="12.5" fill="#FFF0CD" />
                                                <path d="M12.5 8.33594V16.6693" stroke="#FFB60C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M8.33203 12.5H16.6654" stroke="#FFB60C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        )}
                                        {imagePreviews.length > 0 && imagePreviews.length < 5 && (<Box sx={{
                                            width: 100,
                                            height: 100,
                                            marginBottom: 8,
                                            borderRadius: 5,
                                            border: "2px dashed #C4C4C4",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}>
                                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="25" height="25" rx="12.5" fill="#FFF0CD" />
                                                <path d="M12.5 8.33594V16.6693" stroke="#FFB60C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M8.33203 12.5H16.6654" stroke="#FFB60C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </Box>)}
                                        {imagePreviews.length < 5 && (<input
                                            type="file"
                                            accept="image/*"
                                            multiple
                                            style={{
                                                position: "absolute",
                                                width: "100%",
                                                height: "100%",
                                                opacity: 0,
                                                left: 0,
                                                top: 0,
                                                cursor: "pointer",
                                            }}
                                            onChange={handleImageChange}
                                        />)}
                                    </Box>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        sx={{ mt: 1, textAlign: "left", width: isMobile ? 300 : 400 }}
                                    >
                                        {t('photoInfo')}

                                    </Typography>
                                    {imagePreviews.length === 0 && (
                                        <Typography color="error" variant="caption">
                                            {formErrors.images}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        </Grid>
                        {/* Second Column - Pet Information */}
                        <Grid item xs={12} md={4}>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 3, minWidth: isMobile ? 310 : 400, }}>
                                {/* Birthday */}
                                <Box>
                                    <Label htmlFor="birthday" sx={{ display: "block", mb: 1 }}>
                                        {t('DateofBirth')}
                                    </Label>
                                    <DatePickerField
                                        id="birthday"
                                        name="birthday"
                                        placeholder="DD/MM/YYYY"
                                        value={basicInfo.birthday || ""}
                                        onChange={(value) => {
                                            setBasicInfo({ ...basicInfo, birthday: value });
                                            if (formErrors.birthday) {
                                                setFormErrors({ ...formErrors, birthday: "" });
                                            }
                                        }}
                                        onError={(error) =>
                                            setDateErrors({ ...dateErrors, birthday: error })
                                        }
                                    />
                                    {formErrors.birthday && (
                                        <Typography color="error" variant="caption">
                                            {formErrors.birthday}
                                        </Typography>
                                    )}
                                </Box>
                                {/* Sex */}
                                <Box>
                                    <FormLabel component="legend" sx={{ mb: 1 }}>
                                        {t('Gender')}
                                    </FormLabel>
                                    <RadioGroup
                                        name="sex"
                                        value={basicInfo.sex === "male" ? "男" : basicInfo.sex === "female" ? "女" : ""}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setBasicInfo({
                                                ...basicInfo,
                                                sex: value === "男" ? "male" : value === "女" ? "female" : "",
                                            });
                                        }}
                                        sx={{ display: 'flex', gap: 5 }}
                                        row
                                    >
                                        <FormControlLabel
                                            value="男"
                                            control={<Radio />}
                                            label={t('male')}
                                        />
                                        <FormControlLabel
                                            value="女"
                                            control={<Radio />}
                                            label={t('female')}
                                        />
                                    </RadioGroup>
                                </Box>
                                {/* Sterilization */}
                                <Box>
                                    <FormLabel component="legend" sx={{ mb: 1 }}>
                                        {t('Neutered')}
                                    </FormLabel>
                                    <RadioGroup
                                        name="sterilization"
                                        value={basicInfo.sterilization === true ? "是" : basicInfo.sterilization === false ? "否" : ""}
                                        onChange={(e) =>
                                            setBasicInfo({
                                                ...basicInfo,
                                                sterilization: e.target.value === "是" ? true : false,
                                            })
                                        }
                                        sx={{ display: 'flex', gap: 5 }}
                                        row
                                    >
                                        <FormControlLabel
                                            value="是"
                                            control={<Radio />}
                                            label={t('Yes')}
                                        />
                                        <FormControlLabel
                                            value="否"
                                            control={<Radio />}
                                            label={t('No')}
                                        />
                                    </RadioGroup>
                                </Box>

                                {/* Animal */}
                                <Box>
                                    <Label htmlFor="animal" sx={{ display: "block", mb: 1 }}>
                                        {t('Species')}
                                        <span style={{ color: "red", marginLeft: 4 }}>*</span>
                                    </Label>
                                    <FormControl fullWidth error={!!formErrors.animal}>
                                        <Select
                                            id="animal"
                                            name="animal"
                                            value={basicInfo.animal}
                                            onChange={(e) => {
                                                setBasicInfo({ ...basicInfo, animal: e.target.value });
                                                if (formErrors.animal) {
                                                    setFormErrors({ ...formErrors, animal: "" });
                                                }
                                            }}
                                            displayEmpty
                                            sx={{
                                                backgroundColor: "white",
                                                "& .MuiOutlinedInput-root": {
                                                    backgroundColor: "white",
                                                },
                                            }}
                                            MenuProps={{
                                                disableScrollLock: true
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                {t('PleaseSelect')}
                                            </MenuItem>
                                            <MenuItem value="狗">{t('dog')}</MenuItem>
                                            <MenuItem value="貓">{t('cat')}</MenuItem>
                                            <MenuItem value="兔">{t('Rabbit')}</MenuItem>
                                            <MenuItem value="龜">{t('Turtle')}</MenuItem>
                                            <MenuItem value="鳥">{t('Bird')}</MenuItem>
                                            <MenuItem value="蜥蜴">{t('Lizard')}</MenuItem>
                                            <MenuItem value="倉鼠">{t('Hamster')}</MenuItem>
                                            <MenuItem value="其他">{t('other')}</MenuItem>
                                        </Select>
                                        {formErrors.animal && (
                                            <Typography color="error" variant="caption" sx={{ mt: 1 }}>
                                                {formErrors.animal}
                                            </Typography>
                                        )}
                                    </FormControl>
                                </Box>
                                {/* Breed */}
                                <Box>
                                    <Label htmlFor="breed" sx={{ display: "block", mb: 1 }}>
                                        {t('breed')}
                                    </Label>
                                    <FormControl fullWidth>
                                        <Select
                                            id="breed"
                                            name="breed"
                                            value={(() => {
                                                // Determine current breed list based on animal type
                                                const currentBreeds = basicInfo.animal === "狗" ? dogBreeds :
                                                    basicInfo.animal === "貓" ? catBreeds : [];

                                                // If breed exists in current options, use it
                                                if (currentBreeds.includes(basicInfo.breed)) {
                                                    return basicInfo.breed;
                                                }

                                                // If no breed or doesn't exist in options, return empty
                                                return "";
                                            })()}
                                            onChange={(e) =>
                                                setBasicInfo({ ...basicInfo, breed: e.target.value })
                                            }
                                            displayEmpty
                                            disabled={!basicInfo.animal}
                                            sx={{
                                                backgroundColor: "white",
                                                "& .MuiOutlinedInput-root": {
                                                    backgroundColor: "white",
                                                },
                                            }}
                                            MenuProps={{
                                                disableScrollLock: true
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                {t('PleaseSelect')}
                                            </MenuItem>
                                            {basicInfo.animal === "狗" &&

                                                dogBreeds.map((breed) => (
                                                    <MenuItem key={breed} value={breed}>
                                                        {breed}
                                                    </MenuItem>
                                                ))}
                                            {basicInfo.animal === "貓" &&
                                                catBreeds.map((breed) => (
                                                    <MenuItem key={breed} value={breed}>
                                                        {breed}
                                                    </MenuItem>
                                                ))}
                                            {basicInfo.animal === "其他" && (
                                                <MenuItem value="其他">其他</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Box>
                        </Grid>
                        {/* Third Column - More Pet Information */}
                        <Grid item xs={12} md={4}>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 3, minWidth: isMobile ? 310 : 400, }}>
                                {/* Weight */}
                                <Box>
                                    <Label htmlFor="weight" sx={{ display: "block", mb: 1 }}>
                                        {t('weight')}
                                    </Label>
                                    <TextField
                                        id="weight"
                                        name="weight"
                                        placeholder={t('kg')}
                                        type="number"
                                        inputProps={{ min: 0, step: 0.1 }}
                                        value={basicInfo.weight || ""}
                                        onChange={(e) =>
                                            setBasicInfo({ ...basicInfo, weight: e.target.value })
                                        }
                                        fullWidth
                                        variant="outlined"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">KG</InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            backgroundColor: "white",
                                            "& .MuiOutlinedInput-root": {
                                                backgroundColor: "white",
                                            },
                                        }}
                                    />
                                </Box>
                                {/* Description */}
                                <Box>
                                    <Label htmlFor="Description" sx={{ display: "block", mb: 1 }}>
                                        {t('Description')}
                                    </Label>
                                    <TextField
                                        id="Description"
                                        name="Description"
                                        placeholder={t("DesriptionPlaceholder")}
                                        value={basicInfo.description || ""}
                                        onChange={(e) =>
                                            setBasicInfo({ ...basicInfo, description: e.target.value })
                                        }
                                        sx={{
                                            backgroundColor: "white",
                                            width: '100%',
                                            "& .MuiInputBase-input": {
                                                resize: "vertical", // allow vertical resizing
                                                overflow: "auto"
                                            }
                                        }}
                                        multiline
                                    />
                                </Box>
                                {/* remarks */}
                                <Box sx={{ flexGrow: 1 }}>
                                    <Label htmlFor="remarks" sx={{ display: "block", mb: 1 }}>
                                        {t('Remarks')}
                                    </Label>
                                    <TextField
                                        id="Remarks"
                                        name="Remarks"
                                        placeholder={t('RemarksPlaceholder')}
                                        value={basicInfo.remarks || ""}
                                        onChange={(e) =>
                                            setBasicInfo({ ...basicInfo, remarks: e.target.value })
                                        }
                                        sx={{
                                            backgroundColor: "white",
                                            width: '100%',
                                            "& .MuiInputBase-input": {
                                                resize: "vertical", // allow vertical resizing
                                                overflow: "auto"
                                            }
                                        }}
                                        multiline
                                    />
                                </Box>

                            </Box>
                        </Grid>
                    </Grid>
                )}

                {/* Owner remarks Section */}
                <Box sx={{ mt: 6, mb: 2, px: 3 }}>
                    <Typography
                        variant="h6"
                        fontWeight={700}
                        sx={{ mb: 2, color: "#050505" }}
                    >
                        {t('ContactInfo')}
                    </Typography>
                    <Grid container spacing={isMobile ? 3 : 18} >
                        {/* 聯絡人 */}
                        <Grid item xs={12} md={4}>
                            <Label htmlFor="owner" sx={{ display: "block", mb: 1 }}>
                                {t('ContactPerson')}<span style={{ color: "red", marginLeft: 4 }}>*</span>
                            </Label>
                            <TextField
                                id="owner"
                                name="owner"
                                placeholder={t('ContactPerson')}
                                value={basicInfo.owner}
                                onChange={(e) => {
                                    setBasicInfo({ ...basicInfo, owner: e.target.value });
                                    if (formErrors.owner) {
                                        setFormErrors({ ...formErrors, owner: "" });
                                    }
                                }}
                                required
                                fullWidth
                                variant="outlined"
                                error={!!formErrors.owner}
                                helperText={formErrors.owner}
                                sx={{
                                    width: isMobile ? 310 : 400,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "white",
                                    },
                                }}
                            />
                        </Grid>
                        {/* 主要聯絡電話 */}
                        <Grid item xs={12} md={4}>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                <Label htmlFor="ownerContact1">
                                    {t('ContactPhone')}
                                    <span style={{ color: "red", marginLeft: 4 }}>*</span>
                                </Label>

                            </Box>
                            <TextField
                                id="ownerContact1"
                                name="ownerContact1"
                                placeholder={t('ContactPhone')}
                                value={basicInfo.ownerContact1}
                                onChange={(e) => {
                                    handleFieldChange("ownerContact1", e.target.value)
                                    if (formErrors.ownerContact1) {
                                        setFormErrors({ ...formErrors, ownerContact1: "" });
                                    }
                                }
                                }
                                fullWidth
                                variant="outlined"
                                error={
                                    !!formErrors.ownerContact1 || !!fieldErrors.ownerContact1
                                }
                                helperText={
                                    formErrors.ownerContact1 || fieldErrors.ownerContact1
                                }
                                inputProps={{
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                }}
                                sx={{
                                    width: isMobile ? 310 : 400,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "white",
                                    },
                                }}
                            />
                        </Grid>

                    </Grid>
                </Box>

                {/* Bottom Buttons */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        justifyContent: { xs: "center", md: "flex-start" },
                        alignItems: isMobile ? "stretch" : "center",
                        my: 5,
                        mx: 3,
                        gap: 2,
                    }}
                >
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={buttonLoading}
                        sx={{
                            backgroundColor: "#FFB60C",
                            color: "#050505",
                            minWidth: 120,
                            "&:hover": { backgroundColor: "#FFB60C" },
                            "&:disabled": { background: "rgba(255, 182, 12, 0.5)" },
                            cursor: buttonLoading ? "not-allowed" : "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                        }}
                        onClick={handleSubmit}
                    >
                        {t('publish')}
                        {buttonLoading && (
                            <span
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                }}
                            >
                                <CircularProgress size={15} color="inherit" />
                            </span>
                        )}
                    </Button>
                </Box>
                {success && (
                    <Alert
                        severity={
                            success === "寵物資料新增成功！" ||
                                success === "寵物資料更新成功！"
                                ? "success"
                                : "error"
                        }
                        sx={{ mt: 3 }}
                    >
                        {success}
                    </Alert>
                )}
            </Box>
            <Footer />
            {showCurrentMap && (
                <div style={popupOverlayStyle}>
                    <div style={popupContentStyle2}>
                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center", position: "relative", width: "100%", }}>
                                <div style={{ color: "black", fontSize: isMobile ? 15 : 20, fontWeight: 700, }}>{t("SelectCurrentLocation")}</div>
                                <button style={closeButtonStyle} onClick={handleClosePopup}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                        <path d="M22.5 7.5L7.5 22.5" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7.5 7.5L22.5 22.5" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div style={{ display: 'flex', width: '100%' }}>
                            <MapContainer
                                petlost={true}
                                onLocationConfirm={(location) => {
                                    setBasicInfo({ ...basicInfo, lostLocation: location });
                                    setShowCurrentMap(false);
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </Box>
    );
}
